module.exports = __webpack_public_path__ + "img/face-pensive.ef7bcb53.svg";